import Slider from '@ui/Slider/component'

export default (el: HTMLElement): void => {
  if (!el) {
    return
  }

  const sliderEl = el.querySelector<HTMLElement>('.slider')

  if (!sliderEl) {
    return
  }

  const totalSlides = sliderEl.querySelectorAll<HTMLElement>('.slide')

  if (totalSlides.length === 0) {
    return
  }

  Slider(sliderEl, {
    navigation: {
      prevEl: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-navigation .slider-button-prev'),
      nextEl: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-navigation .slider-button-next'),
    },
    pagination: {
      el: sliderEl?.parentElement?.querySelector<HTMLElement>('.slider-pagination') ?? null,
    },
  })
}
